export default __webpack_public_path__ + "static/media/profile.cae7c392.jpg";